const COMMENTS = [
  {
    avatar: '樱',
    name: '樱花飘落',
    content: '甜柚漫画真的是我每天的治愈源泉！霸道总裁系列太甜了，每次看都忍不住姨母笑，画风也很精美，超推荐！',
    manga: '霸道总裁的甜蜜契约',
    time: '2小时前',
  },
  {
    avatar: '星',
    name: '星星不眨眼',
    content: '终于找到能安心看少女漫画的地方了，更新速度快，翻译质量也很好。校草系列我已经三刷了！',
    manga: '校草大人请多指教',
    time: '5小时前',
  },
  {
    avatar: '糖',
    name: '糖果少女',
    content: '青梅竹马的恋爱日记真的太治愈了，每一话都让人心动不已。甜柚漫画的推荐算法也很懂我，总能找到喜欢的作品。',
    manga: '青梅竹马的恋爱日记',
    time: '8小时前',
  },
  {
    avatar: '风',
    name: '风铃草',
    content: '从日漫到韩漫，甜柚漫画的分类很全面。纯爱系列画风超赞，剧情也很细腻。已经推荐给闺蜜们了！',
    manga: '樱花树下的约定',
    time: '1天前',
  },
  {
    avatar: '月',
    name: '月下独酌',
    content: '作为一个漫画老读者，甜柚漫画的排版和阅读体验真的很棒。没有广告干扰，可以沉浸式享受甜蜜故事。',
    manga: '我的恶魔男友',
    time: '1天前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="section-padding bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            读者心声
          </h2>
          <p className="text-foreground-600 mt-2 text-sm md:text-base">甜柚漫画读者们的甜蜜分享</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {COMMENTS.map((c, idx) => (
            <div
              key={idx}
              className={`p-5 rounded-2xl border border-background-200/70 bg-background-50 ${
                idx === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-bold text-sm shrink-0">
                  {c.avatar}
                </div>
                <div>
                  <p className="text-sm font-bold text-foreground-900">{c.name}</p>
                  <p className="text-xs text-foreground-500">{c.time}</p>
                </div>
                <div className="ml-auto flex gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-400 text-xs"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.content}</p>
              <div className="mt-3 flex items-center gap-2">
                <i className="ri-book-open-line text-primary-400 text-sm"></i>
                <span className="text-xs text-primary-500 font-medium">在看《{c.manga}》</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}